export default __webpack_public_path__ + "static/media/cx_cover_cal20s.b38ef946.jpeg";